import { useEffect, useRef, useState } from 'react';

import postApi from 'global/postApi';

/**
 * hook to handle the upvote state for a post
 */
const useUpvotes = ({
  upvotes: _upvotes,
  upvotedByUser: _upvotedByUser,
  id,
}) => {
  const [upvotedByUser, setUpvotedByUser] = useState(!!_upvotedByUser);
  const [upvotes, setUpvotes] = useState(_upvotes || 0);
  const isLoading = useRef(false);

  useEffect(() => {
    setUpvotedByUser(_upvotedByUser);
    setUpvotes(_upvotes || 0);
  }, [_upvotedByUser, _upvotes]);

  const handleUpvote = async (event) => {
    event.stopPropagation();

    if (isLoading.current) {
      return;
    }
    isLoading.current = true;

    if (!upvotedByUser) {
      await postApi.upvotePost({ postId: id });
      setUpvotedByUser(true);
      setUpvotes((upvotes) => upvotes + 1);
    } else {
      await postApi.removeUpvotePost({ postId: id });
      setUpvotedByUser(false);
      setUpvotes((upvotes) => Math.max(0, upvotes - 1));
    }

    isLoading.current = false;
  };

  return {
    upvotedByUser,
    upvotes,
    handleUpvote,
  };
};

export default useUpvotes;
